import { render, staticRenderFns } from "./Shopindex.vue?vue&type=template&id=01c962be&scoped=true"
import script from "./Shopindex.vue?vue&type=script&lang=js"
export * from "./Shopindex.vue?vue&type=script&lang=js"
import style0 from "./Shopindex.vue?vue&type=style&index=0&id=01c962be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c962be",
  null
  
)

export default component.exports